export default function Settings() {
  return (
    <div className="stagger">
      <div style={{ marginBottom: 18 }}>
        <h1 className="h-page">Settings &amp; governance</h1>
        <div className="lead">Your cloud, your keys, your retention policy. The intelligence is ours. The data, and every insight it produces, is yours.</div>
      </div>

      <div className="settings-grid">
        <div className="card">
          <h3>Deployment</h3>
          <div className="s">Where Pulse is installed for this workspace.</div>
          <div className="kv"><div className="k">Cloud</div><div className="v mono">Azure · West Europe (EU-W1)</div></div>
          <div className="kv"><div className="k">Tenant</div><div className="v mono">preethi-kitchen-appliances</div></div>
          <div className="kv"><div className="k">Region lock</div><div className="v">EU · no data egress outside region</div></div>
          <div className="kv"><div className="k">Deployed</div><div className="v">2026-03-12 · version 0.1.4</div></div>
          <div className="kv"><div className="k">Uptime</div><div className="v">99.97% · last 30 days</div></div>
        </div>

        <div className="card">
          <h3>Keys &amp; models</h3>
          <div className="s">Your keys. Your limits. Your audit trail.</div>
          <div className="kv"><div className="k">LLM provider</div><div className="v">Anthropic (via your key)</div></div>
          <div className="kv"><div className="k">Model</div><div className="v mono">claude-opus-4-7 · claude-haiku-4-5</div></div>
          <div className="kv"><div className="k">Key rotation</div><div className="v">Quarterly · next due Jul 2026</div></div>
          <div className="kv"><div className="k">Monthly budget</div><div className="v">₹ 2,40,000 · 34% consumed</div></div>
          <div className="kv"><div className="k">Hard cap</div><div className="v">On · blocks beyond 120%</div></div>
        </div>

        <div className="card">
          <h3>Data retention</h3>
          <div className="s">Transient during answering, then forgotten.</div>
          <div className="kv"><div className="k">Prompts</div><div className="v">Retained 30 days · audit only</div></div>
          <div className="kv"><div className="k">Retrieved rows</div><div className="v">Transient · 0 seconds post-response</div></div>
          <div className="kv"><div className="k">Transcripts</div><div className="v">In your storage · read on demand</div></div>
          <div className="kv"><div className="k">Insights &amp; reports</div><div className="v">Retained until you delete them</div></div>
          <div className="kv"><div className="k">Training</div><div className="v">Your data is never used to train any model</div></div>
        </div>

        <div className="card">
          <h3>Access &amp; roles</h3>
          <div className="s">Four roles, plus fine-grained scope on subjects.</div>
          <div className="kv"><div className="k">Admins</div><div className="v">2 · Mehul S., A. Kulkarni</div></div>
          <div className="kv"><div className="k">Analysts</div><div className="v">6 · full read, saved views</div></div>
          <div className="kv"><div className="k">Reviewers</div><div className="v">3 · can approve harmonisations</div></div>
          <div className="kv"><div className="k">Executives</div><div className="v">12 · Ask, Investigate, Signals only</div></div>
          <div className="kv"><div className="k">SSO</div><div className="v">Azure AD · SAML · MFA required</div></div>
        </div>
      </div>

      <h2 style={{ fontSize: 20, fontWeight: 600, letterSpacing: "-0.012em", marginTop: 28, marginBottom: 6 }}>
        Architecture
      </h2>
      <div style={{ color: "var(--ink-60)", fontSize: 13.5, maxWidth: 720, marginBottom: 14 }}>
        A thin orchestration layer on our side. Everything that touches your data lives inside your cloud boundary.
      </div>

      <div className="arch">
        <div className="arch-box">
          <div className="t">Your Cloud · Azure EU-W1</div>
          <ul>
            <li>Subject repository (quant + qual + social)</li>
            <li>Home, Ask, Investigate, Signals, Brand Health</li>
            <li>Your API keys, your budget, your logs</li>
            <li>Your retention policy</li>
          </ul>
        </div>
        <div className="arch-arrow">
          ←
          <b>Answers</b>
          →
          <b>Prompts</b>
        </div>
        <div className="arch-box dark">
          <div className="t">Info Leap · Orchestration</div>
          <ul>
            <li>Agent brain (planning, drill-down logic)</li>
            <li>Harmonisation models (tagging)</li>
            <li>Transient only · no data retained</li>
            <li>Product IP · protected on our side</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
